<template>
    <div class="row">
        <div class="col">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group" :class="{ 'form-group--error': $v.profile.FirstName.$error}">
                            <label for="first_name">{{'FirstName' | trans}}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="profile.FirstName"
                                id="first_name"
                                :class="status($v.profile.FirstName)"
                                placeholder="John"
                            />
                            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.FirstName.$error">
                                <li v-if="!$v.profile.FirstName.required">{{'This field is required' | trans}}</li>
                            </ul>
                            <form-errors :field-name="'FirstName'" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="middle_name">{{'MiddleName' | trans}}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="profile.MiddleName"
                                id="middle_name"
                                placeholder="Alan"
                            />
                            <form-errors :field-name="'MiddleName'" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group" :class="{ 'form-group--error': $v.profile.LastName.$error}">
                            <label for="last_name">{{'LastName' | trans}}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="profile.LastName"
                                id="last_name"
                                :class="status($v.profile.LastName)"
                                placeholder="Doe"
                            />
                            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.LastName.$error">
                                <li v-if="!$v.profile.LastName.required">{{'This field is required' | trans}}</li>
                            </ul>
                            <form-errors :field-name="'LastName'" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-group--error': $v.profile.C_Country_ID.$error}">
                            <label for="country">{{'Country' | trans}}</label>
                            <select-group
                                v-model="profile.C_Country_ID"
                                :list="countries"
                                :fieldValue="'C_Country_ID'"
                                :fieldText="'Name'"
                                id="country"
                                :className="status($v.profile.C_Country_ID)"
                            >
                                <option value>-- {{'Country' | trans}} --</option>
                                <template slot="after">
                                    <ul class="invalid-feedback list-unstyled" v-if="$v.profile.C_Country_ID.$error">
                                        <li
                                            v-if="!$v.profile.C_Country_ID.required"
                                        >{{'This field is required' | trans}}</li>
                                    </ul>
                                </template>
                            </select-group>
                            <form-errors :field-name="'C_Country_ID'" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-group--error': $v.profile.EMail.$error}">
                            <label for="email">{{'E-mail' | trans}}</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="profile.EMail"
                                id="email"
                                :class="status($v.profile.EMail)"
                            />
                            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.EMail.$error">
                                <li v-if="!$v.profile.EMail.required">{{'This field is required' | trans}}</li>
                                <li v-if="!$v.profile.EMail.email">{{'Email should be valid' | trans}}</li>
                            </ul>
                            <form-errors :field-name="'EMail'" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                        <div class="col-md-12">
                        <div class="form-group" :class="{ 'form-group--error': $v.profile.Phone.$error}">
                            <label for="phone">{{'Phone' | trans}}</label>
                            <span v-show="isPhonePending">
                                <i class="fas fa-pulse fa-spinner"></i>
                            </span>
                            <vue-tel-input @onInput="onInput" class="form-control"
                                    :only-countries="countriesForPhone"
                                    :default-country="getDefaultCountryCode"
                                    :showCode="true"
                                    :placeholder="'Numero de telephone du receveur'"
                                    id="phone"
                                    :disabled="isDisabledPhone"
                                    name="phone"
                                    :valid-characters-only="true"
                                    :v="status($v.profile.Phone)"/>
                            <ul class="invalid-feedback list-unstyled" v-if="$v.profile.Phone.$error">
                                <li v-if="!$v.profile.Phone.required">{{'This field is required' | trans}}</li>
                            </ul>
                            <form-errors :field-name="'Phone'" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="phone2">{{'Phone2' | trans}}</label>
                            <span v-show="isPhone2Pending">
                                <i class="fas fa-pulse fa-spinner"></i>
                            </span>
                            <vue-tel-input
                                @onBlur="VerifyIfUserExists(phone2, phone2Label)"
                                v-model="phone2"
                                name="phone"
                                class="form-control"
                                :placeholder="''"
                                :only-countries="countriesForPhone"
                                :default-country="getDefaultCountryCode"
                                id="phone"
                                :valid-characters-only="true"
                                :showCode="true"
                            />
                            <form-errors :field-name="'Phone2'" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="phone3">{{'Phone3' | trans}}</label>
                            <span v-show="isPhone3Pending">
                                <i class="fas fa-pulse fa-spinner"></i>
                            </span>
                            <vue-tel-input
                                @onBlur="VerifyIfUserExists(phone3, phone3Label)"
                                v-model="phone3"
                                name="phone"
                                class="form-control"
                                :placeholder="''"
                                :only-countries="countriesForPhone"
                                :default-country="getDefaultCountryCode"
                                id="phone"
                                :valid-characters-only="true"
                                :showCode="true"
                            />
                            <form-errors :field-name="'Phone3'" />
                        </div>
                    </div>
                </div>
            </div> -->
            <h5 class="card-title text-center">Adresse</h5>
            <hr />
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <div
                            class="form-group"
                            :class="{ 'form-group--error': $v.address.C_Country_Address_ID.$error}"
                        >
                            <label for="country_address">{{'Country' | trans}}</label>
                            <select-group
                                v-model="address.C_Country_Address_ID"
                                :list="countriesAll"
                                :fieldValue="'C_Country_ID'"
                                :fieldText="'Name'"
                                id="country_address"
                                :className="status($v.address.C_Country_Address_ID)"
                            >
                                <option value>-- {{'Country' | trans}} --</option>
                                <template slot="after">
                                    <ul
                                        class="invalid-feedback list-unstyled"
                                        v-if="$v.address.C_Country_Address_ID.$error"
                                    >
                                        <li
                                            v-if="!$v.address.C_Country_Address_ID.required"
                                        >{{'This field is required' | trans}}</li>
                                    </ul>
                                </template>
                            </select-group>
                            <form-errors :field-name="'address.C_Country_Address_ID'" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="C_Region_ID">{{'Region' | trans}}</label>
                            <select-group
                                v-model="address.C_Region_ID"
                                :list="regionsList"
                                :fieldValue="'C_Region_ID'"
                                :fieldText="'Name'"
                                :isPending="regionIsPending"
                                id="C_Region_ID"
                                name="C_Region_ID"
                                :className="status($v.address.C_Region_ID)"
                                :groupClassName="{ 'form-group--error': $v.address.C_Region_ID.$error}"
                            >
                                <option selected value>-- {{'Region' | trans}} --</option>
                                <template slot="after">
                                    <ul class="invalid-feedback list-unstyled" v-if="$v.address.C_Region_ID.$error">
                                        <li v-if="!$v.address.C_Region_ID.required">{{'This field is required' | trans}}</li>
                                    </ul>
                                </template>
                            </select-group>
                            <form-errors :field-name="'address.C_Region_ID'" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6" :class="{ 'form-group--error': $v.address.ZIP.$error}">
                        <label for="zip">{{'ZIP' | trans}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="address.ZIP"
                            id="zip"
                            :class="status($v.address.ZIP)"
                            placeholder="12345"
                        />
                        <ul class="invalid-feedback list-unstyled" v-if="$v.address.ZIP.$error">
                            <li v-if="!$v.address.ZIP.required">{{'This field is required' | trans}}</li>
                        </ul>
                        <form-errors :field-name="'address.ZIP'" />
                    </div>
                    <div class="col-md-6" :class="{ 'form-group--error': $v.address.City.$error}">
                        <label for="city">{{'City' | trans}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="address.City"
                            id="city"
                            :class="status($v.address.City)"
                            placeholder="New York"
                        />
                        <ul class="invalid-feedback list-unstyled" v-if="$v.address.City.$error">
                            <li v-if="!$v.address.City.required">{{'This field is required' | trans}}</li>
                        </ul>
                        <form-errors :field-name="'address.City'" />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6" :class="{ 'form-group--error': $v.address.Street.$error}">
                        <label for="street">{{'Street' | trans}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="address.Street"
                            id="street"
                            :class="status($v.address.Street)"
                            placeholder="Str."
                        />
                        <ul class="invalid-feedback list-unstyled" v-if="$v.address.Street.$error">
                            <li v-if="!$v.address.Street.required">{{'This field is required' | trans}}</li>
                        </ul>
                        <form-errors :field-name="'address.Street'" />
                    </div>
                    <div class="col-md-3">
                        <label for="buildingNo">{{'Building' | trans}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="address.BuildingNo"
                            id="buildingNo"
                            :class="status($v.address.BuildingNo)"
                            placeholder="#"
                        />
                    </div>
                    <div class="col-md-3">
                        <label for="apartment">{{'Apartment' | trans}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="address.Apartment"
                            id="apartment"
                            :class="status($v.address.Apartment)"
                            placeholder="#"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <spinner-button
                    :className="'btn btn-success btn-secondary'"
                    @click="createProfile"
                    :is-pending="isPending"
                >{{'cauri.Complete' | trans}}</spinner-button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
const {
    required,
    minLength,
    maxLength,
    integer,
    email
} = require("vuelidate/lib/validators");
import { validationMixin } from "vuelidate";
import "./../custom-scripts/vue-tel-input/dist/vue-tel-input.css";
import getCountryCodes from "./../custom-scripts/customCountryList";

export default {
    props: [
        "landingRoute",
        "pSponsorId",
        "skipAddressValidation",
        "typeUser",
        "defaultExpIsoCode",
        "defaultBeneIsoCode"
    ],
    mixin: {
        validationMixin
    },
    data() {
        return {
            isPending: false,
            regionIsPending: false,
            regionsList: [],
            sponsorId: null,
            phonePlaceHolder: "669010101",
            isPhonePending: false,
            isPhone2Pending: false,
            isPhone3Pending: false,
            validPhone: false,
            validPhone2: false,
            validPhone3: false,
        isDisabledPhone:false,
            phone1: "",
            phone2: "",
            phone3: "",
            phone1Label: "Phone",
            phone2Label: "Phone2",
            phone3Label: "Phone3",
            profile: {
                FirstName: "",
                MiddleName: "",
                LastName: "",
                Phone: "",
                C_Country_ID: "",
                EMail: "contact@mycauri.com",
                Phone2: "",
                Phone3: ""
            },
            address: {
                C_Country_Address_ID: "",
                C_Region_ID: "",
                City: "",
                Street: "",
                BuildingNo: "",
                Apartment: "",
                ZIP: ""
            }
        };
    },
    mounted() {
        this.sponsorId = this.pSponsorId;
    },
    computed: {
        ...mapGetters("Application", ["countries", "countriesAll", "regions"]),
        countriesForPhone() {
            const codes = getCountryCodes(this.$store.state.Application.countries);
            if (codes.length) {
                return codes;
            }
        },
        getDefaultCountryCode() {
            // return window.countryCode ? window.countryCode : this.defaultCountry
            return this.typeUser == 0
                ? this.defaultExpIsoCode
                : this.defaultBeneIsoCode
                ? this.defaultBeneIsoCode
                : "GN";
        }
    },
    watch: {
        "address.C_Country_Address_ID": function(countryId) {
            this.address.C_Region_ID = "";
            this.getRegions(countryId);
        },
        "profile.C_Country_ID": function(countryId) {
            this.address.C_Country_Address_ID = countryId;
        },
        pSponsorId(value) {
            this.sponsorId = value;
        }
    },
    methods: {
        onInput({number, isValid, country}) {
            this.phone1 = '00' + country.dialCode + number;
            if(country.dialCode == '225'){
                if(this.phone1.length == 15){
                    this.isPhonePending = true;
                    this.isDisabledPhone = true
                    this.VerifyIfUserExists(this.phone1)
                }
            }else if(isValid){
                this.isPhonePending = true;
                this.isDisabledPhone = true
                this.VerifyIfUserExists(this.phone1)
            }

        },
        async createProfile() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.isPending = true;
                this.$store.commit(
                    `formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`
                );
                var post = this.profile;
                post.address = this.address;
                post.sponsorId = this.sponsorId;
                await axios
                    .post(window.createUserUrl, post)
                    .then(() => {
                        this.EventBus.$emit("event-success", Lang.get("Success"));
                        // after user create find user profile
                        axios
                            .get(`/user/${encodeURIComponent(this.profile.Phone)}/byPhone`)
                            .then(() => {
                                this.$emit("resultat", response.data);
                            });

                        if (this.landingRoute) {
                            setTimeout(
                                () => (window.location.href = this.landingRoute),
                                this.beforeRedirectTimeOut
                            );
                        } else {
                            this.$emit("created", this.profile);
                            this.profile = {};
                        }
                    })
                    .finally(() => (this.isPending = false));
            }
        },
        async getRegions(countryId) {
            this.regionsList = [];
            this.address.C_Region_ID = "";
            if (countryId) {
                this.regionIsPending = true;
                this.regionsList = this.regions(countryId);
                this.regionIsPending = false;
            }
            console.log(this.regionsList);
        },

        VerifyIfUserExists(phone) {
            var self = this
            self.profile.Phone = phone
            self.isPhonePending = true;
            axios.get(`/user/${encodeURIComponent(self.profile.Phone)}/byPhone`)
                .then(function(response) {
                    self.$emit("resultat", response.data);
                    self.isPhonePending = false;
                    self.isDisabledPhone = false
                })
                .catch(function(error) {
                    self.isPhonePending = false;
                    self.isDisabledPhone = false;
                });
            }
        },
        validations() {
            let v = {
                profile: {
                    FirstName: { required },
                    LastName: { required },
                    Phone: { required },
                    C_Country_ID: { required },
                    EMail: { required, email }
                },
                address: {
                    C_Country_Address_ID: { required },
                    C_Region_ID: {},
                    City: { required },
                    Street: {},
                    BuildingNo: {},
                    Apartment: {},
                    ZIP: {}
                }
            };

            if (!this.skipAddressValidation) {
                v.address.ZIP = {};
                v.address.Street = {};

                if (this.regionsList.length > 0) {
                    v.address.C_Region_ID = {};
                }
            }

            return v;
        }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/create-profile.vue